import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('vidJs', ['$document', '$rootScope', '$window', '$timeout', '$q', function ajaxFactory($document, $rootScope, $window, $timeout, $q) {
            var videoId;
            var completed = false;

            this.init = function (vidId, videoUrl, vidElement, additionalOptions) {
                if (!$window.videojs) {
                    $timeout(() => {
                        this.init(vidId, videoUrl, vidElement, additionalOptions);
                    }, 100);
                    return;
                }

                videoId = vidId;
                let options = {
                    controls: true,
                    autoplay: false,
                    preload: 'auto',
                    aspectRatio: '4:3',
                    controlBar: {
                        children: [
                            'playToggle',
                            'volumePanel',
                            'progressControl',
                            'currentTimeDisplay',
                            'timeDivider',
                            'durationDisplay',
                            'remainingTimeDisplay',
                            'captionsButton',
                            'fullscreenToggle',
                        ],
                    },
                };

                if (additionalOptions) {
                    options = angular.extend(options, additionalOptions);
                }

                // set poster of the video
                options.poster = options.image || options.thumbnail || assetUrl('assets/img/white.jpg');

                // set a dummy query string so we don't request from cache and have CORS issue
                videoUrl += '?cache=videoJs';

                let appendString = '<video id="' + videoId + '" class="video-js tv-video-player" crossOrigin="anonymous" playsinline> <source src="' + videoUrl + '" />';
                if (additionalOptions && additionalOptions.captions) {
                    const autoplayCaptions = additionalOptions.autoplayCaptions ? 'default' : '';
                    appendString += ' <track kind="captions" src="' + additionalOptions.captions + '" srclang="en" label="Captions On" ' + autoplayCaptions + '>';
                }
                appendString += '</video>';
                angular.element(vidElement).append(appendString);

                const video = videojs(videoId, options);

                video.ready(function () {
                    const seekDuration = (this.duration() >= 60) ? 10 : 5;
                    this.hotkeys({
                        volumeStep: 0.1,
                        seekStep: seekDuration,
                        enableModifiersForNumbers: false,
                        customKeys: {
                            // Custom hotkey to toggle captions
                            captionKey: {
                                key: function (event) {
                                    // Toggle captions with c
                                    return (event.which === 67);
                                },
                                handler: function (player) {
                                    var tracks = player.textTracks();
                                    var track;

                                    for (var i = 0; i < tracks.length; i++) {
                                        track = tracks[i];
                                        if (track.kind === 'captions') {
                                            if (track.mode !== 'showing') {
                                                track.mode = 'showing';
                                            } else {
                                                track.mode = 'hidden';
                                            }
                                            return;
                                        }
                                    }
                                },
                            },
                        },
                    });
                    // try to overwrite the default control text content
                    // should be a more API-compliant way to do this, but seems to work
                    this.on('fullscreenchange', function () {
                        if (this.isFullscreen()) {
                            var tooltip = $document[0].querySelector('.vjs-fullscreen-control .vjs-control-text');
                            tooltip.textContent = 'Exit Fullscreen';
                            tooltip.parentElement.title = 'Exit Fullscreen';
                        }
                    });

                    $rootScope.$broadcast('player-ready');
                });

                videojs.players[videoId].on('play', function () {
                    completed = false;
                });

                // Fixes Safari bug where autoplay_captions doesn't work
                videojs.players[videoId].on('firstplay', function () {
                    if (!!additionalOptions.autoplayCaptions === false) {
                        if (videojs.players[videoId].textTracks()[0]) {
                            this.textTracks()[0].mode = 'disabled';
                        }
                    }
                });
            };

            this.close = function (vidId) {
                if (!videojs.players[vidId]) {
                    return;
                }

                videojs.players[vidId].dispose();
            };

            this.load = function () {
                videojs.players[videoId].load();
            };

            this.play = function () {
                this.seek(0);
                videojs.players[videoId].play();
            };

            this.seek = function (time) {
                videojs.players[videoId].currentTime(time);
            };

            this.stop = function () {
                if (!videoId || !videojs.players[videoId]) {
                    return;
                }

                videojs.players[videoId].pause();
            };

            // Resets to first frame.
            this.resetVideo = function () {
                videojs.players[videoId].pause();
                videojs.players[videoId].currentTime(0);
                videojs.players[videoId].trigger('ended');
                videojs.players[videoId].trigger('ready');
            };

            this.onReady = function (callback) {
                videojs.players[videoId].on('ready', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onPlay = function (callback) {
                videojs.players[videoId].on('play', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onFirstFrame = function (callback) {
                videojs.players[videoId].on('firstplay', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onTime = function (callback) {
                videojs.players[videoId].on('timeupdate', function () {
                    if (typeof callback === 'function') {
                        var timeObj = {
                            position: videojs.players[videoId].currentTime(),
                            duration: videojs.players[videoId].duration(),
                        };
                        callback(timeObj);
                    }
                });
            };

            this.onPause = function (callback) {
                videojs.players[videoId].on('pause', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            //     this.onBuffer = function (callback) {
            //         jwplayer(videoId).on('buffer', function (time) {
            //             if (typeof callback === 'function')
            //                 callback(time);
            //         });
            //     };

            //     this.onIdle = function (callback) {
            //         jwplayer(videoId).on('idle', function () {
            //             if (typeof callback === 'function')
            //                 callback();
            //         });
            //     };

            this.onVolumeChange = function (callback) {
                videojs.players[videoId].on('volumechange', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onComplete = function (callback) {
                videojs.players[videoId].on('ended', function () {
                    if (typeof callback === 'function' && !completed) {
                        completed = true;
                        callback();
                    }
                });
            };

            this.onError = function (callback) {
                videojs.players[videoId].on('error', function (error) {
                    if (typeof callback === 'function') {
                        callback(error);
                    }
                });
            };

            //     this.onSeek = function (callback) {
            //         jwplayer(videoId).on('seek', function () {
            //             if (typeof callback === 'function')
            //                 callback();
            //         });
            //     };

            //     this.onSetupError = function (callback) {
            //         jwplayer(videoId).on('setupError', function () {
            //             if (typeof callback === 'function')
            //                 callback();
            //         });
            //     };

            //     this.setControls = function (param) {
            //         jwplayer(videoId).setControls(param);
            //     };

            this.getError = function () {
                return videojs.players[videoId].error();
            };

            this.getTime = function () {
                return videojs.players[videoId].currentTime();
            };

            //     this.getState = function () {
            //         return jwplayer(videoId).getState();
            //     };

            //     this.getMute = function () {
            //         return jwplayer(videoId).getMute();
            //     };

            //     this.getVolume = function () {
            //         return jwplayer(videoId).getVolume();
            //     };

            this.setThumbnail = function (thumbnail) {
                videojs.players[videoId].poster(thumbnail);
            };

            this.setVolume = function (perc) {
                // 0.5 = 50% volume.
                if (perc > 1) {
                    perc /= 100;
                }
                videojs.players[videoId].volume(perc);
            };

            //     this.setType = function (type) {
            //         this.type = type;
            //     };

            //     this.getType = function () {
            //         return this.type;
            //     };

            //     this.remove = function () {
            //         jwplayer(videoId).remove();
            //     }

            this.setAudio = function (bool) {
                var q = $q.defer();
                var player = videojs.players[videoId];
                player.muted(!bool);
                if (bool) {
                    if (player.volume() < 70) {
                        player.volume(0.7);
                    }
                    $timeout(() => {
                        var time = player.currentTime();
                        var didStart = time > 0;
                        q.resolve(didStart);
                    }, 500);
                } else {
                    q.resolve(true);
                }
                return q.promise;
            };

            return this;
        }]);
}());
